import { render, staticRenderFns } from "./IgrejaDaLiberdade.vue?vue&type=template&id=6a09dc3b&scoped=true"
import script from "./IgrejaDaLiberdade.vue?vue&type=script&lang=js"
export * from "./IgrejaDaLiberdade.vue?vue&type=script&lang=js"
import style0 from "./IgrejaDaLiberdade.vue?vue&type=style&index=0&id=6a09dc3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09dc3b",
  null
  
)

export default component.exports